core-link {
  display: inline-flex;
}

.core-link {
  display: inline-flex;
}

.core-link .core-anchor {
  display: inline-flex;
  align-items: center;
}

.core-link .core-anchor:hover, .core-link .core-anchor:focus, .core-link .core-anchor:focus-visible {
  text-decoration: none;
}

.core-link .core-anchor:focus-visible {
  outline: 2px solid var(--color-global-border-focus);
  outline-offset: 2px;
  border-radius: var(--number-radius-2xsmall);
}

.core-link--primary a {
  color: var(--color-global-content-link);
}

.core-link--secondary a {
  color: var(--color-neutral-content-medium);
}

.core-link--disabled:hover {
  cursor: not-allowed;
}

.core-link--disabled a {
  pointer-events: none;
  color: var(--color-global-all-disabled-strong);
  text-decoration: none;
}

.core-link .core-anchor core-icon {
  padding-left: var(--number-spacing-4xsmall);
}
